import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

interface InviteLinkCellProps {
  hasUser: boolean;
  hasContact: boolean;
  hasActiveInvite: boolean;
  onSendInvite: () => void;
  disabled?: boolean;
  onAcceptJoinRequest?: () => void;
}

export function InviteLinkCell({
  hasUser,
  hasContact,
  hasActiveInvite,
  onSendInvite,
  disabled = false,
  onAcceptJoinRequest,
}: InviteLinkCellProps) {
  const { t } = useTranslation();

  let state: 'join-requested' | 'no-invite-sent' | 'connected-user-contact' | 'invite-sent';

  if (hasUser && !hasContact) {
    state = 'join-requested';
  } else if (!hasUser && hasContact) {
    if (hasActiveInvite) {
      state = 'invite-sent'
    } else {
      state = 'no-invite-sent';
    }
  }
  else {
    state = 'connected-user-contact';
  }

  const renderAcceptButton = () => {
    if (!onAcceptJoinRequest) return null;

    return (
      <button
        type="button"
        disabled={disabled}
        onClick={(e) => {
          e.stopPropagation();
          onAcceptJoinRequest();
        }}
        className="py-1.5 px-2 inline-flex items-center gap-x-1.5 text-xs font-medium rounded-lg border border-border bg-surface text-onsurface shadow-2xs hover:bg-surface-darker disabled:opacity-50 disabled:pointer-events-none focus:outline-hidden focus:bg-surface-darker"
      >
        <Check className="size-3" />
        {t('employees.table.accept')}
      </button>
    );
  };

  const content = (() => {
    switch (state) {
      case 'join-requested':
        return renderAcceptButton();
      case 'no-invite-sent':
        return (
          <button
            type="button"
            disabled={disabled}
            onClick={(e) => {
              e.stopPropagation();
              onSendInvite();
            }}
            className="py-1.5 px-2 inline-flex items-center gap-x-1.5 text-xs font-medium rounded-lg border border-border bg-surface text-onsurface shadow-2xs hover:bg-surface-darker disabled:opacity-50 disabled:pointer-events-none focus:outline-hidden focus:bg-surface-darker"
          >
            {t('employees.table.sendInvite')}
          </button>
        );

      case 'invite-sent':
        return <span className="text-sm opacity-60">
          {t('employees.table.inviteSent')}
        </span>

      case 'connected-user-contact': return null
    }
  })();


  return <td className="size-px whitespace-nowrap px-4 py-1">
    {content}
  </td>

  // // If user has accepted or there's no contact, show accept button only if new
  // if (inviteAccepted) {
  //   return (
  //     <td className="size-px whitespace-nowrap px-4 py-1">
  //       {renderAcceptButton()}
  //     </td>
  //   );
  // }

  // // If contact and username are present but user is not managed by company and no invite available
  // if (hasContact && hasUser && !managedByCompany && !hasInvite) {
  //   return (
  //     <td className="size-px whitespace-nowrap px-4 py-1">
  //       {renderAcceptButton()}
  //     </td>
  //   );
  // }

  // // If user already exists (accepted invitation)
  // if (hasUser && managedByCompany) {
  //   return (
  //     <td className="size-px whitespace-nowrap px-4 py-1">
  //       <span className="text-sm opacity-60">
  //         {t('employees.table.inviteSent')}
  //       </span>
  //       {renderAcceptButton()}
  //     </td>
  //   );
  // }

  // // Show clickable send invite link
  // if (hasContact && !hasUser) {
  //   return (
  //     <td className="size-px whitespace-nowrap px-4 py-1">
  //       <button
  //         type="button"
  //         onClick={(e) => {
  //           e.stopPropagation();
  //           onSendInvite();
  //         }}
  //         disabled={disabled}
  //         className="text-sm text-primary hover:text-primary-darker hover:underline disabled:opacity-50 disabled:no-underline disabled:cursor-not-allowed"
  //       >
  //         {t('employees.table.sendInvite')}
  //       </button>
  //       {renderAcceptButton()}
  //     </td>
  //   );
  // }

  // return (
  //   <td className="size-px whitespace-nowrap px-4 py-1">
  //     {renderAcceptButton()}
  //   </td>
  // );
}
